import { useOnlineStatus } from '../../hooks/useOnlineStatus';

const OfflineBanner = () => {
    const isOnline = useOnlineStatus();

    if (isOnline) return null;

    return (
        <div className="offline-banner" role="status">
            You're offline — some content may be out of date until your connection is restored.
        </div>
    );
};

export default OfflineBanner;
